import { render, staticRenderFns } from "./BoundClaims.vue?vue&type=template&id=55c1dbdc&scoped=true&"
import script from "./BoundClaims.vue?vue&type=script&lang=js&"
export * from "./BoundClaims.vue?vue&type=script&lang=js&"
import style0 from "./BoundClaims.vue?vue&type=style&index=0&id=55c1dbdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1dbdc",
  null
  
)

export default component.exports